import { gql } from '@apollo/client';

import { MessageFragment } from '../fragments';
import { Message } from '../../types';

export interface MarkMessageAsReadMutationVariables {
  messageId: string;
}

export interface MarkMessageAsReadMutationResult {
  messagesPayload: {
    unseen: number;
    messages: Message[];
  };
}

export const markMessageAsReadMutation = gql`
  mutation MarkMessageAsReadMutation($messageId: String!) {
    messagesPayload(messageId: $messageId, input: {})
      @rest(type: "NotificationsPayload", path: "messages/mark-as-read/{args.messageId}", method: "POST") {
      unseen
      messages @type(name: "Message") {
        ...Message
      }
    }
  }
  ${MessageFragment}
`;
